import Slider from "react-slick";
import { Box, useTheme, useMediaQuery } from "@mui/material";

const ImageCarousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const images = ["download.jfif", "platter.png", "chaap.jfif"];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <Box
      sx={{
        mt: { xs: 0, sm: 5 }, // ✅ Less margin top on mobile
        width: "100%",
        px: { xs: 2, sm: 4 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
        }}
      >
        <Slider {...settings}>
          {images.map((src, index) => (
            <Box
              key={index}
              sx={{
                px: { xs: 1, sm: 2 },
                py: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={src}
                alt={`slide-${index}`}
                sx={{
                  width: "100%",
                  maxHeight: isMobile ? "250px" : "400px",
                  objectFit: "cover",
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default ImageCarousel;
